import { render } from "./CustomChart.vue?vue&type=template&id=1e63a5ae&scoped=true"
import script from "./CustomChart.vue?vue&type=script&lang=js"
export * from "./CustomChart.vue?vue&type=script&lang=js"

import "./CustomChart.vue?vue&type=style&index=0&id=1e63a5ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e63a5ae"]])

export default __exports__